import * as types from '../../actions/types'


export function buffReceived(payload) {
  return {
    payload: payload,
    type: types.BUFF_RECEIVED
  }
}

export function allFilesReceived(payload) {
  return {
    payload: payload,
    type: types.ALL_FILES_RECEIVED
  }
}


// WEBPACK FOOTER //
// ./src/actions/chat/attachmentActions.js